import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import {
  getCustomizationSettingsError,
  getCustomizationSettingsSuccess,
  updateCustomizationSettingsError,
  updateCustomizationSettingsSuccess,
} from './actions'
import {
  CUSTOMIZATION_REQUEST_ASYNC,
  LANGUAGE_CHANGE,
  UPDATE_CUSTOMIZATION_REQUEST,
} from './constants'

const getCustomizationSettingsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      CUSTOMIZATION_REQUEST_ASYNC.INITIATE,
      UPDATE_CUSTOMIZATION_REQUEST.SUCCESS,
      LANGUAGE_CHANGE
    ),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.customization)
      return true
    }),
    mergeMap(() =>
      api.settings
        .getCustomizationSettings(
          state$.value.partnerOptions.selectedCompany?.value,
          state$.value.settings.customization.self.data.locale?.shortName
        )
        .pipe(
          map((response) => getCustomizationSettingsSuccess(response)),
          catchError((error) => of(epicsErrorHandler(getCustomizationSettingsError, error))),
          takeUntil(action$.pipe(ofType(CUSTOMIZATION_REQUEST_ASYNC.CANCEL)))
        )
    )
  )

const updateCustomizationSettingsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(UPDATE_CUSTOMIZATION_REQUEST.INITIATE),
    mergeMap(() =>
      api.settings
        .updateCustomizationSettings(
          state$.value.partnerOptions.selectedCompany?.value,
          state$.value.settings.customization.self.data
        )
        .pipe(
          map((response) => updateCustomizationSettingsSuccess(response)),
          catchError((error) => of(epicsErrorHandler(updateCustomizationSettingsError, error))),
          takeUntil(action$.pipe(ofType(UPDATE_CUSTOMIZATION_REQUEST.CANCEL)))
        )
    )
  )

export default combineEpics(getCustomizationSettingsEpic, updateCustomizationSettingsEpic)
